"use client";

import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-sls-selective-laser-sintering";

const CARDS = [
	{ keyPrefix: "surfaceFinishCard1" },
	{ keyPrefix: "surfaceFinishCard2" },
	{ keyPrefix: "surfaceFinishCard3" },
	{ keyPrefix: "surfaceFinishCard4" },
	{ keyPrefix: "surfaceFinishCard5" },
	{ keyPrefix: "surfaceFinishCard6" },
] as const;

export default function SlsSurfaceFinishes() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#f6f6f6] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-center text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("surfaceFinishesTitle")}
				</h2>

				<div className="grid gap-5 sm:grid-cols-2 md:gap-6">
					{CARDS.map((card) => {
						const hasEffect = !!t(`${card.keyPrefix}EffectLabel` as any);
						return (
							<div key={card.keyPrefix} className="rounded-xl bg-white p-5 shadow-card sm:p-6 md:p-7">
								<h3 className="mb-4 flex items-center gap-2 text-lg font-bold text-black sm:text-xl">
									<span className="inline-block h-5 w-1.5 rounded-sm bg-themePrimary400" aria-hidden />
									{t(`${card.keyPrefix}Title` as any)}
								</h3>

								<div className="space-y-3 text-sm leading-relaxed text-black md:text-base">
									<p>
										<span className="font-semibold text-themePrimary400">
											{t(`${card.keyPrefix}ProcessLabel` as any)}
										</span>{" "}
										{t(`${card.keyPrefix}ProcessDesc` as any)}
									</p>

									{hasEffect && t(`${card.keyPrefix}EffectDesc` as any) && (
										<p>
											<span className="font-semibold text-themePrimary400">
												{t(`${card.keyPrefix}EffectLabel` as any)}
											</span>{" "}
											{t(`${card.keyPrefix}EffectDesc` as any)}
										</p>
									)}

									<p>
										<span className="font-semibold text-themePrimary400">
											{t(`${card.keyPrefix}BenefitLabel` as any)}
										</span>{" "}
										{t(`${card.keyPrefix}BenefitDesc` as any)}
									</p>
								</div>
							</div>
						);
					})}
				</div>

				<div className="mt-8 flex justify-center sm:mt-10">
					<Link
						href="/contact-us"
						className="inline-flex items-center justify-center rounded bg-themePrimary400 px-8 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-themePrimary400/80 hover:text-white md:px-10 md:py-3.5 md:text-base"
					>
						{t("surfaceFinishesContactUs")}
					</Link>
				</div>
			</div>
		</section>
	);
}
